import React from 'react';
import { Box, Link, Typography, Button } from '@mui/material';
// import { GitHub } from '@mui/icons-material';
import Logo from "../icons/hawklogo.Component"
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                py: 2,
                px: 3,
                // backgroundColor: '#ECE5DA',
                // color: '#4A3C31',
                textAlign: 'center',
            }}
        >
            <Box sx={{ borderTop: '1px solid #D4AF37', my: 4 }} />
            {/* Top Section */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                    px: { xs: 3, sm: 3, md: 24, lg: 44 },
                    paddingBottom: '48px'
                }}
            >
                {/* Logo Section */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', maxWidth: '250px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <Logo width="46px" height="46px" margin='0px' />
                        <Button color="inherit" sx={{ textTransform: 'none', padding: '6px 0px', fontWeight: 600, fontSize: '18px' }} onClick={() => navigate('/')}>
                            HawkClient
                        </Button>
                        <Typography style={{ fontSize: '10px' }}> by Prashant Rathi</Typography>
                    </Box>
                    <Typography style={{ fontSize: '10px' }}>A developer and git friendly offline-only API client designed for efficient API testing and development.</Typography>
                </Box>

                {/* Navigation Links */}
                <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: '48px', sm: '48px' } }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant='h8' sx={{ fontWeight: 600, fontSize: '18px' }}>
                            HawkClient
                        </Typography>
                        <Link href="/about" color="inherit" underline="none">
                            About
                        </Link>
                        <Link href="/download" color="inherit" underline="none">
                            Download
                        </Link>
                        {/* <Link href="/demo" color="inherit" underline="none">
                            Demo
                        </Link> */}
                        <Link href="/terms" color="inherit" underline="none">
                            Terms
                        </Link>
                        <Link href="/privacy" color="inherit" underline="none">
                            Privacy Policy
                        </Link>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant='h8' sx={{ fontWeight: 600, fontSize: '18px' }}>
                            Resources
                        </Typography>
                        <Link href="/docs" color="inherit" underline="none">
                            Docs
                        </Link>
                        <Link href="/changelog" color="inherit" underline="none">
                            Changelog
                        </Link>
                        <Link href="https://github.com/prashantrathi123/hawkClient/releases" color="inherit" underline="none" target="_blank">
                            Releases
                        </Link>
                        <Link href="/blog/hawkclient-vs-postman" color="inherit" underline="none">
                            HawkClient vs Postman
                        </Link>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant='h8' sx={{ fontWeight: 600, fontSize: '18px' }}>
                            FeedBack
                        </Typography>
                        <Link href="https://github.com/prashantrathi123/hawkClient" color="inherit" underline="none" target="_blank">
                            Star us on Github
                        </Link>
                        <Link href="https://github.com/prashantrathi123/hawkClient/issues" color="inherit" underline="none" target="_blank">
                            Issues
                        </Link>
                        <Link href="/support" color="inherit" underline="none">
                            Support
                        </Link>
                    </Box>
                </Box>
            </Box>

            {/* Divider */}
            {/* <Box
                sx={{
                    borderTop: '1px solid',
                    borderColor: (theme) => theme.palette.grey[500],
                    my: 2,
                }}
            /> */}

            {/* Social Media Links */}
            {/* <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 2,
                    mb: 2,
                }}
            >
                <IconButton
                    href="https://github.com/prashantrathi123/hawkClient"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: 'inherit' }}
                >
                    <GitHub />
                </IconButton>
            </Box> */}

            {/* Bottom Section */}
        </Box>
    );
};

export default Footer;
